import { render } from "./GoodsDish.vue?vue&type=template&id=4ea9356c"
import script from "./GoodsDish.vue?vue&type=script&lang=js"
export * from "./GoodsDish.vue?vue&type=script&lang=js"

import exportComponent from "E:\\heguang\\hotel\\src\\manage\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__